<template>
    <section class="questions questions--proactive" id="questions">
        <div class="questions__container">
            <p id="title">Proactive News</p>
            <div class="questions__questions">
                <div>
                    <p id="question-action">Question</p>
                    <p id="question">{{Content.en_gb.proactive.questions[0].question}}</p>
                    <button id="yes-answer" @click="updateYesAnswer">Yes</button>
                    <button id="no-answer" @click="updateNoAnswer">No</button>
                    <button id="continue" @click="continueAnswer">Continue</button>
                    <span id="reset" @click="reset">Start Again</span>
                </div>
                <img src="../assets/images/proactive.png" alt="">
            </div>
        </div>
    </section>
</template>
<script>
import Content from "../data/content.js";

    let step = 0;
    let path = '';

    export default {

    name: "Question",
    data() {
        return {
            Content
        };
    },
    methods: {

        async updateYesAnswer() {
            if (path == '') {
                path = 'yes';
            }

            let question = document.getElementById('question');
            let questionAction = document.getElementById('question-action');
            let yes = document.getElementById('yes-answer');
            let no = document.getElementById('no-answer');
            let continueAnswer = document.getElementById('continue');

            if (path == 'yes') {
                if (step > 0 && step < 9) {
                    questionAction.innerText = 'Action';
                    question.innerHTML = Content.en_gb.proactive.emailAnswer;
                    yes.style.display = 'none';
                    no.style.display = 'none';
                } else if (step == 9) { 
                    question.innerHTML = Content.en_gb.proactive.yesPath[step].question;
                    continueAnswer.style.display = 'block';
                    questionAction.innerText = 'Action';
                    yes.style.display = 'none';
                    no.style.display = 'none';
                } else {
                    question.innerHTML = Content.en_gb.proactive.yesPath[step].question;
                }
            } else {
                if (step == 1) {
                    question.innerHTML = Content.en_gb.proactive.noPath[step].question;
                } else if (step == 2) {
                    question.innerHTML = Content.en_gb.proactive.releaseAction;                   
                    questionAction.innerText = 'Action';
                    yes.style.display = 'none';
                    no.style.display = 'none';
                }
            }


            
            step++;
        },

        async updateNoAnswer() {
            if (path == '') {
                path = 'no';
            }

            let question = document.getElementById('question');
            let questionAction = document.getElementById('question-action');
            let yes = document.getElementById('yes-answer');
            let no = document.getElementById('no-answer');
            let continueAnswer = document.getElementById('continue');

            if (path == 'yes') {
                if (step > 0 && step < 9) {
                    question.innerHTML = Content.en_gb.proactive.yesPath[step].question;
                } else if (step == 9) { 
                    questionAction.innerText = 'Action';
                    question.innerHTML = Content.en_gb.proactive.emailAnswer;
                    yes.style.display = 'none';
                    no.style.display = 'none';
                }
            } else {
                if (step == 1 || step == 2) {
                    question.innerHTML = Content.en_gb.proactive.noPath[2].question;
                    continueAnswer.style.display = 'block';
                    questionAction.innerText = 'Action';
                    yes.style.display = 'none';
                    no.style.display = 'none';
                } else if (step == 0) {
                    question.innerHTML = Content.en_gb.proactive.noPath[step].question;
                } else if (step == 9) {
                    questionAction.innerText = 'Action';
                    question.innerHTML = Content.en_gb.proactive.emailAnswer;
                    yes.style.display = 'none';
                    no.style.display = 'none';
                }
            }
            step++;
        },

        async reset() {
            window.location.reload();
        },

        async continueAnswer() {
            let continueAnswer = document.getElementById('continue');
            let question = document.getElementById('question');
            continueAnswer.style.display = 'none';
            question.innerHTML = Content.en_gb.proactive.releaseAction;
        }
    },


};

</script>
<style lang="scss">
.questions {
    padding: 54px 15px;

    @media only screen and (min-width: 768px) {
        padding: 84px 93px 98px;
    }

    &--proactive {
        background: #F6C243;
    }

    &--reactive {
        background: #F2A6B0;
    }

    &__container {
        background: white;
        border-radius: 35.5px;
        background: #FFF;
        padding: 34px 0 89px;
        max-widtH: 1254px;
        margin: 0 auto;
    }

    #title {
        text-align: center;
        color: #242E30;
        text-align: center;
        font-family: 'JetSans-black';
        font-size: 30px;
        font-style: normal;
        font-weight: 800;
        line-height: 140%; /* 70px */

        @media only screen and (min-width: 768px) {
            font-size: 50px;
        }
    }

    &__questions {
        width: 75%;
        max-width: 414px;
        margin: 0 auto;

        @media only screen and (min-width: 768px) {
            width: 75%;
            max-width: 900px;
            margin: 0 auto;
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            align-items: center;
        }

        img {
            max-width: 414px;
            margin-top: 35px;
            width: 100%;

            @media only screen and (min-width: 768px) {
                width: 50%;
                margin-top: 0;
                height: 50%;
            }
        }

        > div {
            max-width: 405px;
            display: flex;
            flex-wrap: wrap;
            justify-content: flex-start;

            @media only screen and (min-width: 768px) {
                width: 50%;
                max-width: 260px;
            }

            @media only screen and (min-width: 1200px) {
                max-width: 350px;
                justify-content: space-between;
            }
        }

        #question {
            font-size: 16px;
            font-style: normal;
            font-weight: 400;
            margin: 0 0 30px 0;
            line-height: 140%;

            @media only screen and (min-width: 768px) {
                font-size: 20px;
            }

            @media only screen and (min-width: 992px) {
                font-size: 25px;
            }
        }

        #question-action {
            font-size: 20px;
            font-style: normal;
            font-weight: 800;
            margin: 0;
            line-height: 140%;
            width: 100%;

            @media only screen and (min-width: 768px) {
                font-size: 25px;
            }

            @media only screen and (min-width: 992px) {
                font-size: 35px;
            }
        }

        button {
            min-width: 0;
            widtH: 150px;
            display: inline-flex;
            padding: 18px 25px;
            justify-content: center;
            align-items: center;
            background: white;
            text-align: center;
            font-size: 18px;
            font-style: normal;
            font-weight: 700;
            line-height: 100%; /* 30px */
            border-radius: 43.091px;
            border: 2.585px solid var(--charcoal, #242E30);
            width: 100px;
            transition: all 0.25s ease-in-out;

            @media only screen and (min-width: 768px) {
                width: 125px;
                font-size: 20px;
                padding: 18px 20px;
            }

            @media only screen  and (min-widtH: 992px) {
                width: 120px;
            }

            @media only screen and (min-width: 1200px) {
                font-size: 25px;
                width: 150px;
            }

            &:hover {
                cursor: pointer;
                background: #EFEDEA;
            }
        }

        #yes-answer {
            margin-right: 15px;

            @media only screen and (min-width: 768px) {
                margin-bottom: 15px;
                margin-right: 15px;
            }

            @media only screen and (min-width: 992px) {
                margin-bottom: 0;
            }

            @media only screen and (min-width: 1200px) {
                margin-right: 50px;
                margin-bottom: 0;
            }
        }

        #continue {
            display: none;
        }

        #reset {
            display: block;
            margin-top: 25px;
            color: #125FCA;
            font-family: "JetSans-Regular", sans-serif;
            font-size: 18px;
            font-style: normal;
            font-weight: 400;
            line-height: 140%; /* 35px */
            text-decoration-line: underline;
            widtH: 100%;

            @media only screen and (min-width: 768px) {
                font-size: 18px;
                margin-top: 30px;
            }

            @media only screen and (min-width: 1200px) {
                margin-top: 50px;
                font-size: 25px;
            }

            &:hover {
                cursor: pointer;
            }
        }
    }
}
</style>